import React from 'react';
import { WithDefaultLayout } from '../components/DefautLayout';
import { Title } from '../components/Title';
import { Page } from '../types/Page';
import { CheckProgram } from '@/components/program/CheckProgram';  
import LmsCarousel  from '@/components/lms/LmsCarousel';
import { HeaderSection } from '@/components/common/headers/HeaderSection';
import ContactUsLms from '@/components/lms/LmsContactUs';
import AllPackageLms from '@/components/lms/LmsPackages';
import LmsDocumentation from '@/components/lms/LmsDocumentation';
import LmsBenefits from '@/components/lms/LmsBenefits';

const LmsIndexPage: Page = () => {
    return (
        <div>
            <Title title={'LMS'} description='' />
            <div>
                <section id='lms' className="bg-white py-6 sm:py-8 mt-5 md:mt-0 md:mb-5">
                    <div className="container overflow-x-hidden overflow-y-hidden mx-auto flex flex-col md:flex-row px-6 md:px-10 lg:px-14 sm:mb-5">
                        <div className="w-full self-center px-2 md:w-1/2 -mb-10">
                            <p className="text-teal-600 text-xl sm:text-2xl font-medium">Learning Management System</p>
                            <h1 className="text-3xl md:text-4xl font-body font-bold text-secondary-100 mb-3  leading-snug sm:whitespace-nowrap ">
                                Anda Instansi atau Lembaga Sekolah?<br className="hidden md:block" />
                                Tapi Belum Memiliki LMS?
                            </h1>
                            <p className='font-body font-semibold text-base md:text-lg text-secondary-100 mb-4 md:whitespace-nowrap'>
                                Kami Hadir sebagai LMS Solution <br />
                                 Penyedia Jasa Pembuatan LMS Lembaga, Perusahaan, dan Sekolah
                            </p>
                            <div className='mr-3 mb-10 space-y-2 text-secondary-100'>
                                <p className='font-body font-semibold text-sm md:text-base'>Butuh LMS? Kami Siap Wujudkan Impian LMS Anda</p>
                                <CheckProgram name='Tanpa ribet, siap pakai' />
                                <CheckProgram name='Custom sesuai kebutuhan Anda' />
                                <CheckProgram name='Integrasi data otomatis' />
                                <CheckProgram name='Support teknis 24/7' />
                                <CheckProgram name='Free konsultasi & demo' />
                            </div>
                        </div>
                        <div className='md:w-1/2 mt-8 md:mt-0 flex justify-center relative z-10'>
                            <div className="relative w-full">
                                <img 
                                 src="/img/lms/img-LMS.jpg" 
                                 alt="img"
                                 className='hidden md:block max-w-[520px] z-10 mt-1 transform translate-x-20 -translate-y-4 ml-10' 
                                />
                                <img
                                 src="/img/lms/Lampu.png"
                                 alt="lampu"
                                 className="hidden md:block absolute top-[25%] left-[10%] w-[8vw] max-w-[120px] h-auto"
                                 />
                                <img
                                 src="/img/lms/Topi.png"
                                 alt="topi"
                                 className="hidden md:block absolute top-[5%] -left-[105%] w-[8vw] max-w-[120px] h-auto"
                                 />
                                <img
                                 src="/img/lms/Medali.png"
                                 alt="medali"
                                 className="hidden md:block absolute top-[2%] -left-[20%] w-[8vw] max-w-[120px] h-auto"
                                 />
                                <img
                                 src="/img/lms/Buku.png"
                                 alt="buku"
                                 className="hidden md:block absolute top-[15%] right-[2%] w-[8vw] max-w-[100px] h-auto"
                                 />
                                <img
                                 src="/img/lms/Pencil.png"
                                 alt="pencil"
                                 className="hidden md:block absolute bottom-[15%] right-[-8%] w-[8vw] max-w-[80px] h-auto"
                                 />
                                <img
                                 src="/img/lms/Laptop.png"
                                 alt="laptop"
                                 className="hidden md:block absolute bottom-[15%] -left-[35%] w-[8vw] max-w-[100px] h-auto"
                                 />
                                <img
                                 src="/img/lms/PencilCase.png"
                                 alt="pencilcase"
                                 className="hidden md:block absolute bottom-[15%] -left-[110%] w-[8vw] max-w-[80px] h-auto"
                                 />
                            </div>
                        </div>
                    </div>
                </section>
                <section id='lms-benefits' className="py-8 relative">
                    <div className="absolute inset-0 bg-lms-benefits opacity-40 z-0"></div>
                    <div className="relative z-10">
                        <div className="flex flex-col text-center mb-2 md:mb-4 items-center">
                            <h2 className="text-black text-4xl font-body font-semibold align-center mt-8">Mengapa LMS Penting?</h2>
                            <div className='border-2 md:border-4 border-accent-100 rounded-full w-36 mt-5 md:mt-7' />
                            </div>
                        <LmsBenefits />
                    </div>
                </section>
                <section className='bg-paket-lms pb-10'>
                    <div id='lms-package-type'>
                        <div className='flex flex-col mx-auto text-center items-center mb-4 md:mb-8'>
                            <h2 className="text-white text-4xl font-body font-semibold align-center mt-10">Paket LMS Solution</h2>
                            <p className="text-white font-body font-light align-center mt-1 md:mt-3 sm:text-lg px-3">Contact us to develop or customize your LMS with us</p>
                            <div className='border-2 md:border-4 border-accent-100 rounded-full w-40 mt-4 md:mt-6' />
                        </div>
                        <AllPackageLms />
                    </div>
                </section>
            </div>
            <section id='lms-features' className="py-10 relative">
                <div className="absolute inset-0 bg-lms-benefits opacity-40 z-0"></div>
                <div className="relative z-10">
                    <div className="flex flex-col text-center mb-2 md:mb-4 items-center">
                        <HeaderSection
                            title="Fitur LMS"
                            subtitle="Default non-custom"
                        />
                    {/* Slider    */}
                    <LmsCarousel/>
                    </div>
                </div>
            </section>
            <section id='lms-documentation'>
                <div className="flex flex-col flex-wrap px-2 pt-1 md:px-4 bg-lms-documentation">
                    <div className="flex flex-col text-center mb-2 md:mb-4 items-center mt-8 ">
                        <HeaderSection
                            title="LMS Documentation"
                            subtitle="Contact us to develop or customize your LMS with us!"
                        />
                        <LmsDocumentation/>
                    </div>
                </div>
            </section>
            <section id='lms-price-info' className='bg-lms-solution'>
                <div className="flex flex-col flex-wrap px-5 md:px-10">
                    <div className="flex flex-col mx-auto text-center mb-8 md:mb-10 items-center mt-10">
                        <h2 className='text-white text-2xl font-body font-bold align-center sm:text-4xl leading-relaxed -mt-2'>Berapa Harganya?</h2>
                        <p className="text-white text-base font-body font-light align-center mt-1 md:mt-3 sm:text-lg mb-7">Mau tau harga dan informasi lebih lanjut? Klik WA admin ya</p>
                        <ContactUsLms useCustomStyles={false} />
                    </div>
                </div>
            </section>
        </div >
    );
}

LmsIndexPage.layout = WithDefaultLayout;
export default LmsIndexPage;